import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AnalyticsService } from './analytics.service';

// automatically tracks navigation events ie: page views
// @segment/analytics-next does not do this out of the box
// implemention is based on AngularRouterTracking and
// Angulartics2.trackUrlChange in angulartics2
@Injectable({
  providedIn: 'root',
})
export class RouteAnalyticsService {
  private destroy$ = new Subject<void>();

  constructor(
    private analyticsService: AnalyticsService,
    private router: Router,
    private location: Location,
  ) {}

  onDestroy() {
    this.destroy$.next();
  }

  public initialize() {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map((e: NavigationEnd) => e.urlAfterRedirects),
        delay(0),
        map((url) => this.location.prepareExternalUrl(url)),
        tap((url) => this.analyticsService.page(url)),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
